import { useMemo, useState } from 'react';
import { useAppSelector } from 'shared/store';
import { selectActiveOrgMembers } from 'shared/store/auth-slice';

export function useOrgMemberSearch() {
  const members = useAppSelector(selectActiveOrgMembers);
  const [search, setSearch] = useState('');

  const filteredMembers = useMemo(() => {
    if (!search) return members;
    const s = search.trim().toLowerCase();
    // Filter on display name, title, and email address.
    // Sort by exact matches first, then sort alphabetially.
    return members
      .filter(
        m =>
          m.displayName?.toLowerCase().includes(s) ||
          m.emailAddress?.toLowerCase().includes(s) ||
          m.title?.toLowerCase().includes(s),
      )
      .sort((a, b) => {
        if (a.displayName?.toLowerCase().startsWith(s)) return -1;
        if (b.displayName?.toLowerCase().startsWith(s)) return 1;
        if (a.emailAddress?.toLowerCase().startsWith(s)) return -1;
        if (b.emailAddress?.toLowerCase().startsWith(s)) return 1;
        if (a.title?.toLowerCase().startsWith(s)) return -1;
        if (b.title?.toLowerCase().startsWith(s)) return 1;
        return a.displayName?.localeCompare(b.displayName);
      });
  }, [members, search]);

  return { search, setSearch, filteredMembers };
}
